export enum CommandProcessIdHandling {
	IGNORING = 'IGNORING',
}

abstract class AbstractCommand {
	public apiVersion = 1;
	public readonly async: boolean = true;
	public parameters:
		| Array<
				Record<
					string,
					| Array<Record<string, unknown>>
					| Array<never>
					| Record<string, unknown>
					| boolean
					| number
					| string
					| string[]
					| undefined
				>
		  >
		| Record<
				string,
				| Array<Record<string, unknown>>
				| Array<never>
				| ArrayBuffer
				| Blob
				| Record<string, unknown>
				| boolean
				| null
				| number
				| number[]
				| string
				| string[]
				| undefined
		  > = {};

	processId: string = CommandProcessIdHandling.IGNORING;

	abstract readonly name: string;
}

export { AbstractCommand };
